import React from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

import { FormItem, FormLabel, FormControl, FormField } from '@/components/v2/Form/Form';
import { Input } from '@/components/v2/Form/Input';

interface ConferenceNameInputProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

export const ConferenceNameInput = <T extends FieldValues>({
  control,
  name,
}: ConferenceNameInputProps<T>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem>
        <FormLabel aria-required>Conference name</FormLabel>
        <FormControl>
          <Input data-cy="conference-name-input" defaultValue={field.value} {...field} />
        </FormControl>
      </FormItem>
    )}
  />
);
